module.exports = __webpack_public_path__ + "media/images/favicon-de6af770ae2830e0e7216730ddb37708.ico";